const state = {
    current: {},
}

const getters = {
    current: state => state.current,
    getByDotNotation: state => key => {
        const keys = key.split('.')
        if (!keys.length) {
            return undefined
        }

        let value = state.current
        keys.every(key => {
            if (value[key] == undefined) {
                value = undefined
                return false
            }

            value = value[key]
            return true
        })

        return value
    },
    getResourceFilters: state => resource => {
        return state.current[resource]
    },
    queryString: state => resource => {
        if (state.current[resource] == undefined) return ''
        const keys = Object.keys(state.current[resource])

        return keys
            .map(key => {
                if (!state.current[resource][key]) {
                    return `filter[${key}]`
                }
                return `filter[${key}]=${encodeURIComponent(
                    state.current[resource][key],
                )}`
            })
            .join('&')
    },
}

const mutations = {
    apply(state, { resource, filter }) {
        let current = JSON.parse(JSON.stringify(state.current))

        if (!current[resource]) {
            current[resource] = {}
        }

        current[resource][filter.name] = filter.value
        state.current = current
    },

    unset(state, { resource, name }) {
        if (state.current[resource][name] === undefined) return

        const current = JSON.parse(JSON.stringify(state.current))
        delete current[resource][name]
        state.current = current
    },

    reset(state, resource) {
        let current = JSON.parse(JSON.stringify(state.current))
        current[resource] = {}
        state.current = current
    },
}

const actions = {
    apply(context, { resource, filter }) {
        if (filter.value === undefined) {
            return context.commit('unset', { resource, name: filter.name })
        }

        return context.commit('apply', { resource, filter })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
